import { useI18n } from '@runtime/core/i18n/i18n'
import CoachPresentationPending from '@/features/coach/CoachPresentationPending'
import styles from './PlayRoutePending.module.scss'

export default function PlayRoutePending() {
  const { t } = useI18n()
  return (
    <>
      <CoachPresentationPending />
      <p className={styles.pending} role="status" data-testid="play-route-pending">
        {t('profile.auth.loading')}
      </p>
    </>
  )
}
